var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 0.344513H4.66667C1.75 0.344513 0.5 2.01118 0.5 4.51118V12.8445C0.5 15.3445 1.75 17.0112 4.66667 17.0112H11.3333C14.25 17.0112 15.5 15.3445 15.5 12.8445V4.51118C15.5 2.01118 14.25 0.344513 11.3333 0.344513ZM4.66667 8.88618H8C8.34167 8.88618 8.625 9.16951 8.625 9.51118C8.625 9.85285 8.34167 10.1362 8 10.1362H4.66667C4.325 10.1362 4.04167 9.85285 4.04167 9.51118C4.04167 9.16951 4.325 8.88618 4.66667 8.88618ZM11.3333 13.4695H4.66667C4.325 13.4695 4.04167 13.1862 4.04167 12.8445C4.04167 12.5028 4.325 12.2195 4.66667 12.2195H11.3333C11.675 12.2195 11.9583 12.5028 11.9583 12.8445C11.9583 13.1862 11.675 13.4695 11.3333 13.4695ZM13.4167 6.38618H11.75C10.4833 6.38618 9.45833 5.36118 9.45833 4.09451V2.42785C9.45833 2.08618 9.74167 1.80285 10.0833 1.80285C10.425 1.80285 10.7083 2.08618 10.7083 2.42785V4.09451C10.7083 4.66951 11.175 5.13618 11.75 5.13618H13.4167C13.7583 5.13618 14.0417 5.41951 14.0417 5.76118C14.0417 6.10285 13.7583 6.38618 13.4167 6.38618Z",
    fill: "#B90022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsactive);
export default __webpack_public_path__ + "static/media/reportsactive.b47683cf474899e0fcae1b0ec503bfd7.svg";
export { ForwardRef as ReactComponent };